import React from "react"

import PopoverMenuOption from "../menu-option"
import {PopoverMenuItemType} from "../const"
import PopoverMenuOptionWithSubmenu from "./menu-option-with-submenu"
import PopoverMenuOptionWithCustomPopover from "../option-with-custom-popover/menu-option-with-custom-popover"
import PopoverMenuSeparator from "../popover-menu-separator"
import PopoverMenuHeader from "../popover-menu-header"
import VScroll from "../../../scrolling/custom-v-scroll/v-scroll"

type Props = {
    menuParams: {
        menuClassName       : string
        option              : {
            icon            : string
            iconComponent   : any
            label           : string
            options         : any[]
        }
        selectedValue       : string
        showMenuSelection   : boolean
        onClick             : func
        hidePopover?        : func
    }
    hidePopover : callback
}

const debug = false
// const debug = "PopoverMenuOptionSubmenu"

export default function PopoverMenuOptionSubmenu(props:Props) {

    debug && console.log(debug, 'render', props)

    return (
        <div className={Classes("ui5-popover-menu", props.menuParams.menuClassName)} style={{minWidth:180}}>
            <VScroll containerClass="max-h-500">
                {_.map(props.menuParams.option.options, (option:any, key:number)=> {
                    if (option.hideInNewSelector) {
                        return false
                    }

                    if (option.type === PopoverMenuItemType.HEADER) {
                        return (
                            <PopoverMenuHeader
                                key={key}
                                title={option.label}
                            />
                        )
                    }

                    if (option.type === PopoverMenuItemType.SEPARATOR) {
                        return <PopoverMenuSeparator key={key}/>
                    }

                    if (option.type === PopoverMenuItemType.CUSTOM_POPOVER) {
                        return (
                            <PopoverMenuOptionWithCustomPopover
                                key         = {key}
                                option      = {option}
                                menuParams  = {option.menuParams}
                            />
                        )
                    }

                    if (option.type === PopoverMenuItemType.SUBMENU) {
                        return (
                            <PopoverMenuOptionWithSubmenu
                                key                 = {key}
                                option              = {option}
                                showMenuSelection   = {props.menuParams.showMenuSelection}
                                onClick             = {props.menuParams.onClick ? (value: any, option: any) => props.menuParams.onClick(option.value, value, option) : undefined}
                                hidePopover         = {props.menuParams.hidePopover}
                            />
                        )
                    }

                    return (
                        <PopoverMenuOption
                            key             = {key}
                            option          = {option}
                            iconComponent   = {option.iconComponent}
                            selected        = {props.menuParams.showMenuSelection && option.value === props.menuParams.selectedValue}
                            onClick         = {props.menuParams.onClick ? () => props.menuParams.onClick(option.value, option) : undefined}
                            hidePopover     = {props.menuParams.hidePopover}
                        />
                    )
                })}
            </VScroll>
        </div>
    )
}
